import { Card, CardBody, Col } from "reactstrap";
import Swal from "sweetalert2";
import { Button } from "reactstrap";
import { AutoCloseAlertTitle, Primary, Timer } from "../../../constants";
import { AutoCloseAlertSubTitle } from "../../../data/bonusUi/SweetAlert";
import CommonCardHeader from "../../../coreComponents/CommonCardHeader";

//This component displays a button that triggers an alert which automatically closes after 3 seconds.
const AutoCloseAlert = () => {
  const handleAlert = () => {
    Swal.fire({
      title: "Auto close alert!",
      text: "just wait! I will close in 3 second!",
      timer: 3000,
      showConfirmButton: false,
      confirmButtonColor: Primary,
    });
  };
  return (
    <Col xxl="3" lg="4" sm="6" xs="12">
      <Card>
        <CommonCardHeader title={AutoCloseAlertTitle} span={AutoCloseAlertSubTitle} />
        <CardBody className="btn-showcase">
          <Button color="primary" onClick={handleAlert}>
            {Timer}
          </Button>
        </CardBody>
      </Card>
    </Col>
  );
};
export default AutoCloseAlert;
